import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  selectFormStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer } from "react-toastify";
import { FaCircleExclamation, FaEye, FaEyeSlash } from "react-icons/fa6";

// Formik InitialValues
const initialValues = {
  password: "",
  newPassword: "",
  confirmPassword: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  password: Yup.string().required("Password is required"),
  newPassword: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()?"])[A-Za-z\d!@#$%^&*()?"]{12,}$/,
      "Please ensure your password is at least 12 characters long and includes a mix of uppercase and lowercase letters, numbers, and special characters (! “ ? $ % ^ &).Avoid using common words, personal information, or easily guessed patterns"
    )
    .required("Password is required"),
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf(
      [Yup.ref("newPassword")],
      "The new password and confirm password do not match. Please re-enter both fields correctly."
    ),
});

const ChangePassword = () => {
  ChangeTitle("Change Password");
  const [loading, setLoading] = useState();
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [isNewPasswordShow, setIsNewPasswordShow] = useState(false);
  const [isConfirmPasswordShow, setIsConfirmPasswordShow] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Change Password Api Call
  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        oldPassword: values.password,
        newPassword: values.newPassword,
      };

      const response = await postData(
        "private/user/password/change",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Change password
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full lg:w-[50%] p-[3rem] mx-auto relative form-box">
            <div className="">
              <form onSubmit={formik.handleSubmit}>
                <div className="w-full grid grid-cols-1 gap-[2rem] gap-y-[2rem] mb-[2rem]">
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Old password
                    </label>
                    <div className="relative">
                      <input
                        className="w-full form-input"
                        type={isPasswordShow ? "text" : "password"}
                        placeholder="Enter old password"
                        name="password"
                        id="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                      />
                      {isPasswordShow == true ? (
                        <FaEyeSlash
                          onClick={() => setIsPasswordShow(false)}
                          className="absolute cursor-pointer top-[1.5rem] right-[2.5rem] auth-input-eye"
                        />
                      ) : (
                        <FaEye
                          onClick={() => setIsPasswordShow(true)}
                          className="absolute cursor-pointer top-[1.5rem] right-[2.5rem] auth-input-eye"
                        />
                      )}
                    </div>
                    {formik.touched.password && formik.errors.password && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.password}</div>
                      </div>
                    )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      New password
                    </label>
                    <div className="relative">
                      <input
                        className="w-full form-input"
                        type={isNewPasswordShow ? "text" : "password"}
                        placeholder="Enter new password"
                        name="newPassword"
                        id="newPassword"
                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                      />
                      {isNewPasswordShow == true ? (
                        <FaEyeSlash
                          onClick={() => setIsNewPasswordShow(false)}
                          className="absolute cursor-pointer top-[1.5rem] right-[6rem] auth-input-eye"
                        />
                      ) : (
                        <FaEye
                          onClick={() => setIsNewPasswordShow(true)}
                          className="absolute cursor-pointer top-[1.5rem] right-[6rem] auth-input-eye"
                        />
                      )}
                      <FaCircleExclamation
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                        className="absolute cursor-pointer top-[1.5rem] right-[2.5rem] auth-input-eye auth-input-info"
                      />
                      {showTooltip && (
                        <div className="tooltip">
                          <div className="tooltip-arrow"></div>
                          <p className="tooltip-title">
                            Your password must have:
                          </p>
                          <ul className="tooltip-list">
                            <li>have at least one number</li>
                            <li>have at least one uppercase character</li>
                            <li>have at least one lowercase character</li>
                            <li>have at least one special character</li>
                            <li>be 12 characters minimum</li>
                          </ul>
                        </div>
                      )}
                    </div>
                    {formik.touched.newPassword &&
                      formik.errors.newPassword && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.newPassword}</div>
                        </div>
                      )}
                  </div>
                  <div className="w-full flex flex-col">
                    <label
                      htmlFor=""
                      className="w-full form-input-label required mb-4"
                    >
                      Re-type password
                    </label>
                    <div className="relative">
                      <input
                        className="w-full form-input"
                        type={isConfirmPasswordShow ? "text" : "password"}
                        placeholder="Enter re-type password"
                        name="confirmPassword"
                        id="confirmPassword"
                        value={formik.values.confirmPassword}
                        onChange={formik.handleChange}
                      />
                      {isConfirmPasswordShow == true ? (
                        <FaEyeSlash
                          onClick={() => setIsConfirmPasswordShow(false)}
                          className="absolute cursor-pointer top-[1.5rem] right-[2.5rem] auth-input-eye"
                        />
                      ) : (
                        <FaEye
                          onClick={() => setIsConfirmPasswordShow(true)}
                          className="absolute cursor-pointer top-[1.5rem] right-[2.5rem] auth-input-eye"
                        />
                      )}
                    </div>
                    {formik.touched.confirmPassword &&
                      formik.errors.confirmPassword && (
                        <div className="mt-2 error-msg">
                          <div className="">
                            {formik.errors.confirmPassword}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                <div className="w-full justify-center gap-5 flex">
                  <button
                    type="submit"
                    className="btn-submit"
                    disabled={loading}
                  >
                    {!loading && <>Change password</>}
                    {loading && (
                      <div className="flex items-center gap-3">
                        <span className="" style={{ display: "block" }}>
                          Please wait...{" "}
                        </span>
                        <ClipLoader
                          color={"#ffffff"}
                          loading={loading}
                          size={20}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
